import { render, staticRenderFns } from "./DrawBox.vue?vue&type=template&id=72aaf399&scoped=true"
import script from "./DrawBox.vue?vue&type=script&lang=js"
export * from "./DrawBox.vue?vue&type=script&lang=js"
import style0 from "./DrawBox.vue?vue&type=style&index=0&id=72aaf399&prod&scoped=true&lang=css"
import style1 from "./DrawBox.vue?vue&type=style&index=1&id=72aaf399&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72aaf399",
  null
  
)

export default component.exports